import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
const Card = ({
  benefit,
  delay
}: {
  benefit: any;
  delay: number;
}) => {
  const cardRef = useRef<HTMLDivElement>(null);
  const [rotateX, setRotateX] = useState(0);
  const [rotateY, setRotateY] = useState(0);
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!cardRef.current) return;
    const rect = cardRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    const rotateXValue = (y - centerY) / centerY * -5;
    const rotateYValue = (x - centerX) / centerX * 5;
    setRotateX(rotateXValue);
    setRotateY(rotateYValue);
  };
  const handleMouseLeave = () => {
    setRotateX(0);
    setRotateY(0);
  };
  return <motion.div ref={cardRef} className="bg-white rounded-2xl p-8 shadow-[0_10px_40px_rgba(0,0,0,0.08)] border border-gray-100 flex flex-col h-full cursor-pointer" initial={{
    opacity: 0,
    y: 50
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    delay,
    duration: 0.6,
    type: 'spring',
    bounce: 0.4
  }} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave} animate={{
    rotateX,
    rotateY
  }} style={{
    transformStyle: 'preserve-3d',
    perspective: 1000
  }} data-id="element-33">
      <div className="text-4xl mb-6" style={{
      transform: 'translateZ(30px)'
    }} data-id="element-34">
        {benefit.icon}
      </div>
      <h3 className="text-xl font-bold text-black mb-4" style={{
      transform: 'translateZ(20px)'
    }} data-id="element-35">
        {benefit.title}
      </h3>
      <p className="text-gray-600 mb-8 flex-grow" style={{
      transform: 'translateZ(10px)'
    }} data-id="element-36">
        {benefit.body}
      </p>
      <div className="text-[#D4AF37] font-bold text-sm tracking-wide uppercase mt-auto" style={{
      transform: 'translateZ(20px)'
    }} data-id="element-37">
        → {benefit.arrow}
      </div>
    </motion.div>;
};
export const Benefits = () => {
  const {
    t
  } = useLanguage();
  const cards = t('benefits.cards');
  const benefits = [{
    icon: '🌐',
    title: cards[0].title,
    body: cards[0].body,
    arrow: cards[0].arrow
  }, {
    icon: '💰',
    title: cards[1].title,
    body: cards[1].body,
    arrow: cards[1].arrow
  }, {
    icon: '👔',
    title: cards[2].title,
    body: cards[2].body,
    arrow: cards[2].arrow
  }, {
    icon: '🔓',
    title: cards[3].title,
    body: cards[3].body,
    arrow: cards[3].arrow
  }, {
    icon: '📍',
    title: cards[4].title,
    body: cards[4].body,
    arrow: cards[4].arrow
  }, {
    icon: '⚡',
    title: cards[5].title,
    body: cards[5].body,
    arrow: cards[5].arrow
  }];
  return <section className="py-32 bg-[#F8F9FA] overflow-hidden" data-id="element-38">
      <div className="container mx-auto px-6" data-id="element-39">
        <motion.h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-black mb-20 max-w-3xl mx-auto" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-40">
          {t('benefits.heading')}
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-41">
          {benefits.map((b, i) => <Card key={i} benefit={b} delay={i * 0.2} data-id="element-42" />)}
        </div>
      </div>
    </section>;
};